import React, { ReactNode, createContext, useContext, useState } from 'react';

type GlobalLoadingContextData = {
  isGlobalLoading?: boolean;
  setIsGlobalLoading?: (isLoading: boolean) => void;
};

const GlobalLoadingContext = createContext<GlobalLoadingContextData>({} as GlobalLoadingContextData);

export const GlobalLoadingProvider = ({ children }: { children: ReactNode }) => {
  const [isGlobalLoading, setIsGlobalLoading] = useState(false);

  return (
    <GlobalLoadingContext.Provider
      value={{
        isGlobalLoading,
        setIsGlobalLoading,
      }}
    >
      {children}
    </GlobalLoadingContext.Provider>
  );
};

export const useGlobalLoadingContext = () => useContext(GlobalLoadingContext);
